import * as React from "react";
export function SvgDataCatalogLineageMetricWhite(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M18 5c.51 0 .935.388.993.884L19 6v13c0 .51-.388.935-.884.993L18 20H5c-.51 0-.935-.388-.993-.884L4 19V6c0-.51.388-.935.884-.993L5 5h13zm0 1H5v13h13V6zm-1.878 3.84l.707.706-4.591 4.531L9.2 12.193l-1.993 1.993-.707-.706 2.673-2.674 3.038 2.884 3.911-3.85z"
      />
    </svg>
  );
}
